export default __webpack_public_path__ + "static/media/title_vi_pc.f8ec6c9c.png";